import React, { useCallback, useState } from 'react';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import type { ProcessedStoreRow } from '../../../utils/storeSummaryTransform';

interface StoreSummaryStoreCellProps {
  row: ProcessedStoreRow;
}

const StoreSummaryStoreCell: React.FC<StoreSummaryStoreCellProps> = ({ row }) => {
  const [copied, setCopied] = useState(false);
  const storeKey = row.raw.store_key || '';

  const handleCopyStoreKey = useCallback(async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    if (!storeKey) {
      return;
    }

    if (!navigator.clipboard?.writeText) {
      return;
    }

    try {
      await navigator.clipboard.writeText(storeKey);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
    } catch {
      setCopied(false);
    }
  }, [storeKey]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
      <Typography sx={{ fontSize: '13px', fontWeight: 600, lineHeight: 1.2, minWidth: 0 }} noWrap>
        {row.name}
      </Typography>
      <Tooltip title={copied ? 'Copied store key' : 'Copy store key'}>
        <span>
          <IconButton
            aria-label="Copy store key"
            disabled={!storeKey}
            onClick={handleCopyStoreKey}
            size="small"
            sx={{ color: '#637381', flexShrink: 0, p: 0.25 }}
          >
            <ContentCopyRoundedIcon sx={{ fontSize: 14 }} />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default React.memo(StoreSummaryStoreCell);
